/**
 * 51esc web — entry point: `/portaaviones.html`.
 *
 * Ready room del CVN-51 (Fase 5g.3). Escena inmersiva con 6 hotspots y
 * un reloj digital de pared. Se llega desde el hotspot "EMBARCAR" de la
 * sala de operaciones (home).
 */

import { initReadyRoom } from './modules/ready-room/index.js';

initReadyRoom();
